const { cELM, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Block = require("../components/blocks/index");

class CareTeamMemberModule {
    constructor(type, value, parent) {
        this.type = type;
        this.value = value;
        this.parent = parent;
        this.typingIndicator = null;
        this.contentHash = {};
        const cssVariableKey = getAnswerVariableCssClass(value);
        this.elContainer = cELM("div", `care-team-module ${cssVariableKey}`);
    }

    getHTML() {
        return this.elContainer;
    }

    getELM() {
        return this.elContainer;
    }

    clearAfterId(id) {
        const index = this.contentHash[id][0];
        const newHash = {};

        Object.keys(this.contentHash).forEach(key => {
            const ch = this.contentHash[key];
            if (ch[0] >= index) {
                this.elContainer.removeELM(ch[1]);
            } else {
                newHash[key] = ch;
            }
        });

        this.contentHash = newHash;

        if (this.parent && this.parent.clearAfterId) {
            const questionsRemaining = Object.keys(this.contentHash);
            if (questionsRemaining.length === 0) {
                // Clear everything becasue there are no remaining questions in this component
                this.parent.clearAfterId(this.value.id);
            }
            else {
                // Clear everything after but not this component
                this.parent.clearAfterId(this.value.id, null, true);
            }
        }
    }

    handle(type, value) {
        if (this.typingIndicator) {
            this.elContainer.removeELM(this.typingIndicator);
            this.typingIndicator = null;
        }

        const element = this.handleOnMessage(value);
        if (!element) {
            return;
        }

        if(element._option && element._option._element && element._option._element.reset) {
            element._option._element.reset();
        }

        this.elContainer.addELM(element);

        if (value.status !== "typing") {
            Scroller.scrollToElm(element, () => {
                element.focus();
            });
        }
    }

    handleOnMessage(value) {
        let identifier = value.values.id;

        if (identifier.indexOf("/answer") > -1) {
            const idParts = identifier.split("/answer/");
            identifier = idParts[0] + "/" + idParts[1];
            const question = this.contentHash[identifier][1];
            const values = value.values;
            question.updateAnswer(value.values, this.clearAfterId.bind(this));
        }
        else if (this.contentHash[value.id]) {
            component = this.mapFormat(value);
            this.contentHash[identifier] = [
                Object.keys(this.contentHash).length,
                component
            ];
        }
        else if (!this.contentHash[identifier]) {
            component = this.mapFormat(value);
            if (value.status === "typing" || value.id && value.id.indexOf("/") === -1) {
                this.typingIndicator = component;
                identsplit = (identifier || "").split("suggestions/");
                identifier = identsplit[0] + identsplit[1];

                // This is done this way because sometimes the component is removed from the contentHash and it crashes
                if (this.contentHash[identifier]) {
                    component = this.contentHash[identifier][1];
                }
                else {
                    return component;
                }

                if (
                    value.continue === false &&
                    component._option._element.updateSuggestions
                ) {
                this.typingIndicator = null;
                component._option._element.updateSuggestions(
                    (value.values || []).suggestions,
                    {
                        sendObject: true // Send the whole object not just the name
                    }
                );
                return;
                }
            } else {
                this.contentHash[identifier] = [
                    Object.keys(this.contentHash).length,
                    component
                ];
            }
        }
        else {
            component = this.mapFormat(value);
            this.contentHash[identifier] = [
                Object.keys(this.contentHash).length,
                component
            ];
        }

        return component;
    }

    mapFormat(value) {
        const params = {
            data: value.values,
            answer: value.values.answer
         };

        return new Block(params);
    }
}

module.exports = CareTeamMemberModule;
